( function( app ) {
  const COMPONENT = {
    init: function() {
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'vertical-treatment-hero', COMPONENT );
} )( app );
